import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { CalendarHeart } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EASE = [0.22, 1, 0.36, 1];

// Prise de rendez-vous : un simple pont vers l'agenda Resalib de Julie.
// Plus de planning intégré à l'application.
export default function Reservation() {
  const [resalibUrl, setResalibUrl] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/settings/public`)
      .then(({ data }) => setResalibUrl(data.settings.resalib_url || ""))
      .catch(() => setResalibUrl(""));
  }, []);

  return (
    <main className="rav-page" data-testid="reservation-page">
      <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE }}>
        <img src="/logo-accueil.webp" alt="Respire Aime Vibre" className="rav-page-logo" />
        <h1 className="rav-page-title">Prendre rendez-vous</h1>
        <p className="rav-page-sub">
          Choisissez votre moment en toute liberté, directement sur l'agenda en ligne de Julie.
        </p>
        {resalibUrl ? (
          <>
            {/* L'agenda s'ouvre DANS l'application : la navigation RAV reste en place */}
            <div className="rav-resalib-frame" data-testid="reservation-frame">
              <iframe src={resalibUrl} title="Agenda en ligne de Julie" className="rav-resalib-iframe" />
            </div>
            <a className="rav-text-link" data-testid="reservation-resalib-button" href={resalibUrl} target="_blank" rel="noreferrer">
              <CalendarHeart size={15} strokeWidth={1.6} /> Ouvrir l'agenda dans un nouvel onglet
            </a>
          </>
        ) : (
          resalibUrl !== null && (
            <p className="rav-page-sub" data-testid="reservation-soon">
              L'agenda en ligne ouvre bientôt — en attendant, écrivez-nous depuis la page Échanger.
            </p>
          )
        )}
      </motion.div>
    </main>
  );
}
